import { ApiPath } from "enums";
import { Get, Post, Put } from "utils";

export const getExpenseListApi = async (query) => {
  const res = await Get(`${ApiPath.Expense}/station/${query?.stationCode}`, query);
  return res.data;
};

export const createExpenseApi = async (query) => {
  const res = await Post(`${ApiPath.Expense}`, query);
  return res.data;
};

export const getExpenseByIdApi = async (query) => {
  const res = await Get(`${ApiPath.Expense}/${query?.id}`, query);
  return res.data;
};

export const updateExpenseByIdApi = async (query) => {
  const res = await Put(`${ApiPath.Expense}/${query?.id}`, query);
  return res.data;
};
